import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from 'src/lib/utils';

const TooltipEditorProvider = TooltipPrimitive.Provider;

const TooltipEditor = TooltipPrimitive.Root;

const TooltipEditorTrigger = TooltipPrimitive.Trigger;

const TooltipEditorContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipEditorProvider>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]',
        className,
      )}
      {...props}
    />
  </TooltipEditorProvider>
));
TooltipEditorContent.displayName = TooltipPrimitive.Content.displayName;

export { TooltipEditor, TooltipEditorTrigger, TooltipEditorContent, TooltipEditorProvider };
